import React, { useState } from "react";
import Modal from "../../components/Modal";
import Input from "../../components/Input";
import styles from "./index.module.scss";
import Button from "../../components/Button";

type Props = {
  onSave: (mealGroupName: string) => void
  onCancel: () => void
};

const NewMealGroupModal = (props: Props) => {

  const [mealGroupName, setMealGroupName] = useState<string>('')

  return <>
    <Modal title={'New meal'} onClose={props.onCancel}>
      <Input type={'text'} placeholder={'Name'} onChange={(value: string) => setMealGroupName(value)} />
      <div className={styles.button_group}>
        <Button onClick={() => {props.onSave(mealGroupName)}} type={'success'}>Save</Button>
        <Button onClick={props.onCancel} type={'simple'}>Cancel</Button>
      </div>
    </Modal>
  </>;
};

export default NewMealGroupModal;
